import {
  MultipleDogAnimation,
  SingleDogAnimation,
  FirstAnimation,
} from "../work-modules/020/dogAnimation";

document.addEventListener("DOMContentLoaded", () => {
  //アニメーションの開始
  const work020 = document.getElementById("work020");
  if (!work020) return;
  work020.classList.add("animation-start");
  new FirstAnimation().init();

  // 管理クラスのインスタンス作成
  const eyeManager = new MultipleDogAnimation();
  const Dogs = document.querySelectorAll(".dog");
  Dogs.forEach((svg, index) => {
    eyeManager.trackers.set(index, new SingleDogAnimation(svg as SVGElement, index));
  });
});
